module.exports = __webpack_public_path__ + "static/media/sun-haze.a89aae5c.svg";